/* eslint-disable import/prefer-default-export */
export const colors = {
  primary: 'bg-slate-400',
  secondary: 'bg-slate-300',
  tertiary: 'bg-slate-100',
};
